import CompareSave from './CompareSave'

export default CompareSave
